module.exports = __webpack_public_path__ + "img/vol05_character_thumb04.b47d6f5e.png";